if  (window.location.pathname.includes('references')) {
    // On construit l'Url du site
    const url = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port;

    // On récupère le noeud d'affichage des actus
    const events = document.querySelector('.events-list');

    // On récupère le bouton
    const loadmoreButton = document.querySelector('#loadmore');

    // On init à 1
    let currentPage = 1;

    // On regarde où se situer dans le temps
    let counter = document.querySelector('#countEvent').value;

    loadmoreButton.addEventListener('click', () => {
        currentPage++;
        fetchevents(currentPage)
    })

    function fetchevents(currentPage) {
        fetch(
            url + '/wp-admin/admin-ajax.php',
            {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                    'Accept': 'application/json'
                },
                body: new URLSearchParams({
                    action : 'load_more',
                    paged : currentPage,
                    countTime: counter,
                })
            }
        )
        .then(response => response.json())
        .then(data => {
            function displayLoadmore(){
                if (currentPage >= data.max) {
                    // console.log(loadmoreButton);
                    loadmoreButton.classList.remove('d-block');
                    loadmoreButton.classList.add('d-none');
                }
            
                else {
                    loadmoreButton.classList.remove('d-none');
                    loadmoreButton.classList.add('d-block');
                }
            }
            events.insertAdjacentHTML('beforeEnd', data.html);
            displayLoadmore();

        })
        .catch(error => {
            console.log(error);
        })
    }

}